<script>
  import { get } from "svelte/store"
  import { getContext, onMount } from "svelte";
  import GanttChartBox from "../../components/ganttchart/GanttChartBox.svelte";
  import Loading from "../../components/pages/Loading.svelte";
  import { usePageContext } from "../../components/pages/pageContext.js";
  import { FetchError, fetchOrderGanttProjectInfo, fetchGlobalProjectData} from "../../utils/getData";
  import { batchUpdateGanttStore, initGanttStore } from "../../components/ganttchart/ganttStore/init.js";
  import {
    mapProjectInfoToGanttStoreProperties
  } from "../../components/ganttchart/ganttStore/mapProjectInfoToGanttStoreProperties.js";
  import {
    connectExpectedActualCmpConfigurationToGanttStore
  } from "../../views/generic/ExpectedActualCmp/ExpectedActualCmpConfigurationStorage.js";
  import { createExpectedActualCmpFilters } from "../../views/generic/ExpectedActualCmp/ExpectedActualCmpFilters.js";

  export let projectId;
  export let user;

  const GanttStore = initGanttStore()

  const order_url = `/api/projects/${projectId}/OrderGantt/Order/`;
  let projectInfo = null;

  // New GanttChart vars
  let projectData;
  let uploadTimeStamp;
  let styleDict;
  let readyToRender = false;


  const { setHeaderProps } = usePageContext();
  $: setHeaderProps({
    title: projectInfo?.Project?.[5]
      ? `${projectInfo.Project[5]} (${"予実比較"})`
      : "予実比較",
  });
  $: setHeaderProps({uploadTime: uploadTimeStamp})

  const { handleFetchErrors } = getContext("fetchErrorHandler");

  function fetchStyleInfo(styles) {
    const _styleDict = {};
    styles.forEach((style) => {
      const _styleUrl = `/api/projects/${projectId}/OrderGantt/styles/${style.ObjectID}.json`;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", _styleUrl, false);
      xhr.send();
      if (xhr.status === 200) {
        _styleDict[style.StyleName] = JSON.parse(xhr.responseText);
      } else {
        console.error("Failed to fetch style " + style);
      }
    });
    styleDict = _styleDict;
  }

  onMount(async () => {
    try {
      projectInfo = await fetchOrderGanttProjectInfo(projectId);
      projectData = projectInfo.Project;
      uploadTimeStamp = projectInfo.UploadTimeStamp;
      fetchStyleInfo(projectData[7]);

      // Do not support dayStartTime, OtherDemarcationTimes for simple gantt charts for now
      batchUpdateGanttStore(GanttStore, {
        ...mapProjectInfoToGanttStoreProperties(projectInfo),
        GanttChartType: GanttStore.GanttChartTypes.ExpectedActualCmp,
        ProjectId: projectId,
        RowDownloadUrl: order_url,
        StylesDict: styleDict,
        User: user.id,
        ExtraColumns: [
          {
            name: "製番",
            nameTranslationKey: "製番",
            code: "Order_Seiban",
            filterName: "OrderSeibanFilter",
            expectedLength: 6,
            displayed: false,
          },
          {
            name: "品目",
            nameTranslationKey: "品目",
            code: "Order_ItemCode",
            filterName: "OrderItemCodeFilter",
            expectedLength: 10,
            displayed: false,
          },
          {
            name: "品名",
            nameTranslationKey: "品名",
            code: "Order_ItemName",
            filterName: "OrderItemNameFilter",
            expectedLength: 15,
            displayed: false,
          },
          {
            name: "完成予定日",
            nameTranslationKey: "完成予定日",
            code: "Order_EndTime",
            expectedLength: 10,
            displayed: false,
          },
          {
            name: "納期",
            nameTranslationKey: "$t(asprova.terms.due)",
            code: "Order_LET",
            expectedLength: 10,
            displayed: false,
          },
          {
            name: "納期遅れ",
            nameTranslationKey: "$t(asprova.terms.lateness)",
            code: "Order_Lateness",
            expectedLength: 3,
            displayed: false,
          },
        ],
      })
      GanttStore.Filters.set(createExpectedActualCmpFilters(get(GanttStore.RowsAllOwnedByStyle)))
      await connectExpectedActualCmpConfigurationToGanttStore(GanttStore, user.id, projectId)
      readyToRender = true;
    } catch (e) {
      console.error(e);
      if (e instanceof FetchError) {
        handleFetchErrors(e.error);
      }
    }
  });
</script>

{#if readyToRender === true}
  <GanttChartBox
    GanttStore={GanttStore}
    boxDimensions="height: calc(100% - 5px);"
  />
{/if}
{#if projectInfo == null}
  <Loading />
{/if}
